import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoModule } from '@jsverse/transloco';
import { LanguageStore } from 'shared/domain';

import { SelectImports } from '../select';

@Component({
  standalone: true,
  imports: [MatSelectModule, ReactiveFormsModule, TranslocoModule, SelectImports, FormsModule, AsyncPipe],
  selector: 'app-language-picker',
  templateUrl: './language-picker.component.html',
})
export class LanguagePickerComponent {
  protected languageStore = inject(LanguageStore);

  @Input() public currentLanguage: string;
  @Input() public useSameLanguageOnly: boolean;
  @Input() public disabled = false;

  @Output() public languageChanged = new EventEmitter<string>();

  constructor() {
    this.languageStore.loadAllLanguages();
  }
}
